import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import EmotionBanner from './components/EmotionBanner';
import HowItWorksSection from './components/HowItWorksSection';
import PricingSection from './components/PricingSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import FeedbackSection from './components/FeedbackSection';
import SubscriptionBanner from './components/SubscriptionBanner';
import Footer from './components/Footer';
import PrivacySection from './components/PrivacySection';
import { SectionDivider } from './components/SectionDivider';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
function HomePage() {
  return <>
      <Navbar data-id="element-0" />
      <main className="flex-grow" data-id="element-1">
        <HeroSection data-id="element-2" />
        <SectionDivider data-id="element-3" />
        <FeaturesSection data-id="element-4" />
        <EmotionBanner data-id="element-5" />
        <SectionDivider data-id="element-6" />
        <PrivacySection data-id="element-7" />
        <CTASection data-id="element-8" />
        <FeedbackSection data-id="element-9" />
        <SubscriptionBanner data-id="element-10" />
        <FAQSection data-id="element-11" />
        <PricingSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </>;
}
export function App() {
  document.title = 'Emigo';
  return <BrowserRouter data-id="element-14">
      <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-15">
        <Routes data-id="element-16">
          <Route path="/" element={<HomePage data-id="element-18" />} data-id="element-17" />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-20" />} data-id="element-19" />
          <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-22" />} data-id="element-21" />
        </Routes>
      </div>
    </BrowserRouter>;
}